import { Box, Button, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router';

const ReachOut = () => {
    const theme = useTheme();
    const navigate = useNavigate()

    const _handleDownload = async () => {
        try {
            const response = await fetch("/images/bandhran.PDF");
            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(
                new Blob([blob], {
                    type: "image/png/jpg/jpeg/pdf",
                })
            );

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = "Bandharan.pdf";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading blob:", error);
        }
    };

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    backgroundImage: `url('${'/images/FrameGradient.jpg'}')`,
                    backgroundSize: "100%",
                    padding: { lg: "109px 0px", md: "80px 0px", sm: "60px 0px", xs: "40px 0px" }
                }}
            >
                <Box
                    textAlign={"center"}
                    sx={{
                        width: { lg: "60%", md: "80%", sm: "100%", xs: "100%" },
                        m: "auto",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
                            fontWeight: 500,
                        }}
                        color={"primary"}
                    >
                        Reach out to us - we’re here to help!
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { lg: "22px", md: "14px", sm: "13x", xs: "12px" },
                            paddingX: { lg: "0px", md: "0px", sm: "8px", xs: "4px" },
                            color: '#222'
                        }}
                    >
                        If you have any questions, ideas, or need assistance, don’t hesitate
                        to reach out to us. Our team is always ready to support you and
                        provide the information you need to move forward confidently.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button
                            sx={{
                                mt: 2,
                                width: '138px',
                                padding: '6px 14px',
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: '10px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                                fontSize: '16px',
                                fontFamily: 'Lato, sans-serif',
                                textTransform: 'none',
                                zIndex: 1,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.main,
                                },
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    width: 0,
                                    height: 0,
                                    top: '50%',
                                    left: '50%',
                                    backgroundColor: '#9e110c',
                                    borderRadius: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: -1,
                                    transition: 'all 500ms ease-in-out',
                                },
                                '&:hover::before': {
                                    width: '300px',
                                    height: '300px',
                                },
                            }}
                            onClick={() => navigate(`/contact-us`)}
                        >
                            Get in Touch
                        </Button>
                    </Box>
                    <Typography
                        sx={{
                            fontSize: { lg: "20px", md: "14px", sm: "13x", xs: "12px" },
                            paddingX: { lg: "0px", md: "0px", sm: "8px", xs: "4px" },
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            mt: 2
                        }}
                        onClick={() => _handleDownload()}
                    >
                        વધુ માહિતી માટે અહીં ક્લિક કરો
                    </Typography>
                </Box>
            </Box>
        </div>
    )
}

export default ReachOut
